import { call, put } from 'redux-saga/effects';
import { backendClient } from '../../../services/api/backend-client';
import { updateUserCredential } from '../../../state/userCredential/userCredentialSlice';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import bugsnagClient from '../../../services/bugsnag/bugsnag';

export function* setDefaultCrmSaga(action) {
    const { crm } = action.payload;
    try {
        const { data } = yield call(
            [backendClient, backendClient.patch],
            'integrations/default-crm',
            { crm: crm || null }
        );
        yield put(updateUserCredential({ defaultCrm: data.defaultCrm }));
        yield put(showSnackbar({
            message: data.defaultCrm ? `Default CRM set to ${data.defaultCrm}.` : 'Default CRM cleared.',
            severity: 'info',
        }));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to set default CRM:', err?.response?.status, err?.message);
        yield put(showSnackbar({ message: 'Failed to update default CRM.', severity: 'error' }));
    }
}